<template>
  <div>
    <template>
      <div v-loading="loading" element-loading-spinner="nucleus-loader" id="reviewDashboard">
        <el-row :gutter="10" type="flex">
          <el-col id="projectPane" :span="5" :class="isClosed ? 'projectsClosed' : 'projectsOpen'" style="display: flex; padding-right: 0px;">
            <el-card class="dataCard reviewCard" shadow="hover">
              <div>
                <el-date-picker v-model="dateRange" type="daterange" range-separator="To" start-placeholder="Start date" end-placeholder="End date" :picker-options="dateRangePickerConfig" format="MM/dd/yyyy" value-format="MM-dd-yyyy" style="width: 100%;" @change="handleCriteriaChange"> </el-date-picker>
              </div>

              <el-input :value="searchInput" @input="searchInput = $event" placeholder="Filter Projects" clearable style="margin: 10px 0px 0px 0px; width: 100%;"> </el-input>

              <el-select v-if="localClients.length" ref="subClients" style="margin: 10px 0px 0px 0px; width: 100%;" :default-first-option="true" v-model="subClients" placeholder="Add Clients" multiple filterable clearable collapse-tags @visible-change="handleSubClientChange" @clear="handleSubClientClear">
                <!-- <el-option value="selectAll" label="Select All"></el-option> -->
                <el-option v-for="client in localClients" :key="client.clientNumber" :label="(client.clientNumber + ' | ' + client.clientName).replace(/(.{40})..+/, '$1…')" :value="client.clientNumber"> </el-option>
              </el-select>

              <el-select v-if="dashboardProjects.some(s => s.projectTypeId === 2)" ref="projectTypes" style="margin: 10px 0px 0px 0px; width: 100%;" :default-first-option="true" v-model="projectTypes" placeholder="Select Project Type" multiple filterable clearable collapse-tags>
                <!-- <el-option value="selectAll" label="Select All"></el-option> -->
                <el-option :key="1" :label="'Client Review'" :value="1"></el-option>
                <el-option :key="2" :label="'Coding QA Review'" :value="2"></el-option>
              </el-select>
              <div style="margin: 10px 0px 0px 0px; width: 100%;position: relative;">
                <div v-if="betaFeatures()" style="position: absolute; right: 0; margin: 7px 0px 0px 0px; z-index: 99;">
                  <el-dropdown title="Options" style="float: right;" trigger="click" @command="projectCommands" size="medium">
                    <span class="el-dropdown-link">
                      <i class="mdi mdi-dots-horizontal ellipsesIcon"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" style="width: 200px;" class="documentActionMenu">
                      <el-dropdown-item v-if="betaFeatures()" :command="{ action: 'viewInterimSummary' }"><i style="margin-right: 6px;" class="mdi mdi-file-document-box-outline"></i>View Interim Summary </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <el-table ref="projectList" id="projectList" :data="compDashboardProjects" empty-text="No Projects Available" :fit="true" @selection-change="handleSelectionChange" @select-all="handleSelectionAll" :row-class-name="disableProjectSelection" :height="dashboardProjects.length ? 300 : 120">
                  <el-table-column type="selection" width="26"> </el-table-column>
                  <el-table-column prop="projectID" label="Projects" sortable fixed>
                    <template slot-scope="scope">
                      <div><i style="font-size: 15px; margin: 0px 5px 0px 1px;" class="mdi mdi-tab"></i>{{ scope.row.projectID }}</div>
                      <div style="margin-top: 0px;">
                        <i style="font-size: 17px; margin:0px 5px 0px 0px;" class="mdi mdi-calendar-month-outline"></i>{{ scope.row.startDate }} -
                        {{ scope.row.endDate }}
                        <el-dropdown title="Project Options" style="float: right;" trigger="click" @command="projectCommands" size="medium">
                          <span class="el-dropdown-link">
                            <i class="mdi mdi-dots-horizontal ellipsesIcon"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown" style="width: 200px;" class="documentActionMenu">
                            <el-dropdown-item
                              :command="{
                                action: 'openDocMgr',
                                directoryLink: scope.row.directoryLink
                              }"
                              :disabled="scope.row.directory === null"
                              ><i style="margin-right: 6px;" class="mdi mdi-folder-multiple-outline"></i>{{ 'Document Manager' }}
                            </el-dropdown-item>
                            <!-- <el-dropdown-item v-if="betaFeatures() && scope.row.serviceLineID === 7" :command="{action: 'viewInterimSummary', row: scope.row}"><i style="margin-right: 6px;" class="mdi mdi-file-document-box-outline"></i>View
                              Interim Summary
                            </el-dropdown-item> -->
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                      <div style="margin-top: 0px;">
                        <el-popover placement="bottom" width="400" trigger="click">
                          <div>Review Timeline</div>
                          <el-table :data="scope.row.reviewTimeLine">
                            <el-table-column width="40" prop="id" label="">
                              <template slot-scope="scope">
                                <i v-if="scope.row.description === 'Completed'" style="color: #7cbe5f; font-size: 18px;" class="mdi mdi-check-bold"></i>
                                <i v-if="scope.row.description !== 'Completed'" style="color: rgba(236, 0, 140, 0.8); font-size: 20px;" class="mdi mdi-clock-alert-outline"></i>
                              </template>
                            </el-table-column>
                            <el-table-column width="170" prop="item" label="Item"></el-table-column>
                            <el-table-column prop="description" label="Description"></el-table-column>
                            <el-table-column prop="date" label="Date"></el-table-column>
                          </el-table>
                          <div slot="reference">
                            <el-alert v-if="!scope.row.reviewTimeLine.length" class="reviewTimeline" show-icon style="padding: 0px 0px 0px 0px; width: 90%;" :closable="false" :title="getProjectStatusLabel('Not Started')" type="info"> </el-alert>
                            <el-alert v-if="checkReviewTimelineDataStatus(scope.row.reviewTimeLine, 'Not Started')" class="reviewTimeline" show-icon style="padding: 0px 0px 0px 0px; width: 90%;" :closable="false" :title="getProjectStatusLabel('Not Started')" type="info"> </el-alert>
                            <el-alert v-if="checkReviewTimelineDataStatus(scope.row.reviewTimeLine, 'Project Ready')" class="reviewTimeline" show-icon style="padding: 0px 0px 0px 0px; width: 90%;" :closable="false" :title="getProjectStatusLabel('Project Ready')" type="warning"> </el-alert>
                            <el-alert v-if="checkReviewTimelineDataStatus(scope.row.reviewTimeLine, 'In Progress')" class="reviewTimeline" show-icon style="padding: 0px 0px 0px 0px; width: 90%;" :closable="false" :title="getProjectStatusLabel('In Progress')" type="error"> </el-alert>
                            <el-alert v-if="checkReviewTimelineDataStatus(scope.row.reviewTimeLine, 'Preliminary')" class="reviewTimeline" show-icon style="padding: 0px 0px 0px 0px; width: 90%;" :closable="false" :title="'Preliminary'" type="warning"> </el-alert>
                            <el-alert v-if="checkReviewTimelineDataStatus(scope.row.reviewTimeLine, 'Final')" class="reviewTimeline" show-icon style="padding: 0px 0px 0px 0px; width: 90%;" :closable="false" :title="'Final'" type="success"> </el-alert>
                          </div>
                        </el-popover>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="dataTableStats">
                  <p>{{ selectedProjects.length }} selected</p>
                </div>
              </div>
              <el-button style="width: 100%; margin: 20px 0px 0px 0px;" :disabled="!selectedProjects.length" @click="getReviewDashboardData($event)" type="success" plain><i style="font-size: 18px; margin: -3px 0px 0px -22px; position: absolute;" class="mdi mdi-download"></i> Get Project Data</el-button>
              <div style="margin: 50px 0px 0px 0px;">
                <div style="text-align: left; margin: 0px 0px 10px 0px; font-weight: 300;">
                  Project Consultants
                </div>
                <el-table :show-header="false" id="projectConsultants" :data="getProjectConsultants" empty-text="No Consultants Available" :fit="true" :height="getProjectConsultants.length > 3 ? 250 : 150">
                  <el-table-column prop="consultant" label="Consultant" width="50" sortable fixed>
                    <template slot-scope="scope">
                      <avatar :fullname="scope.row.consultantName" :image="scope.row.photo" :size="30"></avatar>
                    </template>
                  </el-table-column>
                  <el-table-column prop="projectID" label="Project" sortable>
                    <template slot-scope="scope">
                      <span style="white-space: pre-line">{{ scope.row.projectID }}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="dataTableStats">
                  <p>{{ getProjectConsultants.length }} consultants</p>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="19" :class="isClosed ? 'reviewGridClosed' : 'reviewGridOpen'">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-tabs id="reviewTabs" v-model="activeReviewTab" @tab-click="handleReviewTabClick">
                  <el-tab-pane :disabled="!ipData" label="Inpatient" name="ip"></el-tab-pane>
                  <el-tab-pane :disabled="!opData" label="Outpatient" name="op"></el-tab-pane>
                  <el-tab-pane :disabled="!proData" label="Professional Fee" name="pro"></el-tab-pane>
                  <el-tab-pane :disabled="!ambData" label="Ambulatory" name="amb"></el-tab-pane>
                </el-tabs>
              </el-col>
            </el-row>

            <el-row>
              <ReviewDashboardInpatient ref="reviewDashIP" v-show="activeReviewTab === 'ip'" @expandCollapse="expandCollapse" :isClosed="isClosed" :bedSizeDropdown="bedSizeDropdown" @comparisonLoading="comparisonLoading" :dateRange="dateRange" :selectedProjects="selectedProjects"> </ReviewDashboardInpatient>
              <ReviewDashboardOutpatient ref="reviewDashOP" v-show="activeReviewTab === 'op'" @expandCollapse="expandCollapse" :isClosed="isClosed" :bedSizeDropdown="bedSizeDropdown" @comparisonLoading="comparisonLoading" :dateRange="dateRange"></ReviewDashboardOutpatient>
              <ReviewDashboardProfee ref="reviewDashPro" v-show="activeReviewTab === 'pro'" @expandCollapse="expandCollapse" :isClosed="isClosed" :bedSizeDropdown="bedSizeDropdown" @comparisonLoading="comparisonLoading" :dateRange="dateRange"></ReviewDashboardProfee>
              <ReviewDashboardAmbulatory ref="reviewDashAmb" v-show="activeReviewTab === 'amb'" @expandCollapse="expandCollapse" :isClosed="isClosed" :bedSizeDropdown="bedSizeDropdown" @comparisonLoading="comparisonLoading" :dateRange="dateRange"></ReviewDashboardAmbulatory>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </template>
  </div>
</template>

<script>
import axios from '@/utilities/axios-global'
import { format } from 'date-fns'
import HiaAuthorization from '@/mixins/hiaAuthorization'
import money from '@/mixins/money'
import { mapState, mapActions, mapMutations } from 'vuex'
import ReviewDashboardInpatient from '@/views/Dashboards/ReviewDashboardInpatient'
import ReviewDashboardOutpatient from '@/views/Dashboards/ReviewDashboardOutpatient'
import ReviewDashboardAmbulatory from '@/views/Dashboards/ReviewDashboardAmbulatory'
import ReviewDashboardProfee from '@/views/Dashboards/ReviewDashboardProfee'
import avatar from '@/components/avatar'
import debounce from 'debounce'

export default {
  data: function() {
    return {
      selectAllProjects: false,
      searchInput: '',
      searchQuery: '',
      projectTypes: [1, 2],
      localClients: [],
      subClients: [],
      loading: false,
      initLoading: false,
      reviewLoading: false,
      dateRange: [],
      isClosed: false,
      activeReviewTab: 'ip',
      grouping: '',
      dropdown: [{ key: '1', value: 'coder' }, { key: '2', value: 'physician' }, { key: '3', value: 'reviewer' }],
      bedSizeDropdown: [{ key: '0 - 99', value: '0 - 99' }, { key: '100 - 199', value: '100 - 199' }, { key: '200 - 299', value: '200 - 299' }, { key: '300 - 500', value: '300 - 500' }, { key: '500+', value: '500+' }]
    }
  },
  name: 'ReviewDashboard',
  mixins: [HiaAuthorization, money],
  props: {},
  components: {
    ReviewDashboardInpatient,
    ReviewDashboardOutpatient,
    ReviewDashboardProfee,
    ReviewDashboardAmbulatory,
    avatar
  },
  methods: {
    ...mapActions('dashboard/', ['GET_DASHBOARD_PROJECTS', 'POST_REVIEW_DASHBOARD_ALL', 'POST_DASHBOARD_PROJECTS_MULTIPLE', 'GET_INTERIM_SUMMARY_PDF_URL']),
    ...mapMutations('dashboard/', ['SET_SELECTED_PROJECTS', 'CLEAR_REVIEW_DASHBOARD', 'CLEAR_REVIEW_DASHBOARD_FILTERS', 'SET_DASHBOARD_COMPARISON_ACCOUNTS', 'SET_DASHBOARD_COMPARISON_ACCOUNTS_OP', 'SET_DASHBOARD_COMPARISON_ACCOUNTS_PRO']),
    getCombinedStickyAccountNumbersForFilters(filters) {
      if (!filters || !filters.length) {
        return null
      }

      let combined = new Set(filters[0].selectedAccountNumbers || [])

      filters.slice(1).forEach(filter => {
        const filterIds = new Set(filter.selectedAccountNumbers || [])
        combined = new Set([...combined].filter(id => filterIds.has(id)))
      })

      return combined.size ? [...combined] : []
    },
    getCombinedStickyAccountNumbers(reviewType) {
      switch (reviewType) {
        case 'op':
          return this.getCombinedStickyAccountNumbersForFilters(this.outpatientStickyGroupingFilters)
        case 'amb':
          return this.getCombinedStickyAccountNumbersForFilters(this.ambulatoryStickyGroupingFilters)
        case 'pro':
          return this.getCombinedStickyAccountNumbersForFilters(this.proStickyGroupingFilters)
        case 'ip':
        default:
          return this.getCombinedStickyAccountNumbersForFilters(this.inpatientStickyGroupingFilters)
      }
    },
    initialize() {
      let now = new Date()
      this.dateRange[0] = format(new Date(now.getFullYear() - 1, now.getMonth(), 1), 'MM-dd-yyyy')
      this.dateRange[1] = format(new Date(now.getFullYear(), now.getMonth() + 1, 0), 'MM-dd-yyyy')

      let payload = {
        startDate: this.dateRange[0],
        endDate: this.dateRange[1]
      }
      this.loading = true
      this.initLoading = true
      this.reviewLoading = true
      // nuke current dashboard
      this.CLEAR_REVIEW_DASHBOARD('')

      axios.all([this.GET_DASHBOARD_PROJECTS(payload)]).then(() => {
        this.loading = false
        this.initLoading = false
        this.reviewLoading = false
      })

      // copy all clients and remove current client
      this.localClients = JSON.parse(JSON.stringify(this.clients))
      const reviewDashboardRoleId = 12
      this.localClients = this.localClients.filter(f => f.clientNumber !== this.currentClient && this.userInRoleByClient(f.clientNumber, reviewDashboardRoleId))
    },
    moneyFormatter(row, column) {
      return `$${this.formatMoney(row.totalCharges)}`
    },
    handleCriteriaChange() {
      let payload = {
        currentClient: this.currentClient,
        startDate: this.dateRange[0],
        endDate: this.dateRange[1]
      }
      this.loading = true
      this.reviewLoading = true
      this.GET_DASHBOARD_PROJECTS(payload).then(() => {
        this.loading = false
        this.reviewLoading = false
        this.activeTabChanger()
      })
    },
    handleReviewTabClick(tab, event) {
      // console.log(tab, event)
    },
    handleSelectionChange(val) {
      var valCopy = []
      val.forEach((x, i) => {
        if (!x.reviewTimeLine.length || this.isPrePreliminaryStatus(x.reviewTimeLine[0].dataStatus)) {
          this.$refs.projectList.toggleRowSelection(x)
        } else {
          valCopy.push(x)
        }
      })
      this.SET_SELECTED_PROJECTS(valCopy)
    },
    handleSelectionAll(val) {
      this.selectAllProjects = !this.selectAllProjects
      if (!this.selectAllProjects) {
        this.$refs.projectList.clearSelection()
        this.SET_SELECTED_PROJECTS([])
      }
    },
    getReviewDashboardData(event) {
      ;['reviewDashIP', 'reviewDashOP', 'reviewDashPro', 'reviewDashAmb'].forEach(refName => {
        const child = this.$refs[refName]
        if (!child) {
          return
        }

        if (Object.prototype.hasOwnProperty.call(child, 'openFilterEditorGrouping')) {
          child.openFilterEditorGrouping = null
        }

        if (typeof child.resetFilterGroupSelectionSource === 'function') {
          child.resetFilterGroupSelectionSource()
        }

        if (Object.prototype.hasOwnProperty.call(child, 'selectedGrouping')) {
          child.selectedGrouping = []
        }

        if (Object.prototype.hasOwnProperty.call(child, 'pendingSelectedGrouping')) {
          child.pendingSelectedGrouping = []
        }
      })
      this.CLEAR_REVIEW_DASHBOARD_FILTERS('')

      let payload = {
        startDate: this.dateRange[0],
        endDate: this.dateRange[1],
        projects: this.selectedProjects,
        selectedAccountNumbersIP: this.getCombinedStickyAccountNumbers('ip'),
        selectedAccountNumbersOP: this.getCombinedStickyAccountNumbers('op'),
        selectedAccountNumbersAMB: this.getCombinedStickyAccountNumbers('amb'),
        selectedAccountNumbersPRO: this.getCombinedStickyAccountNumbers('pro'),
        inpatientGrouping: this.inpatientGrouping,
        outpatientGrouping: this.outpatientGrouping,
        ambulatoryGrouping: this.ambulatoryGrouping,
        proGrouping: this.proGrouping
      }

      this.loading = true
      this.POST_REVIEW_DASHBOARD_ALL(payload).then(() => {
        this.loading = false
        this.activeTabChanger()
      })

      // remove focus on button
      event.target.blur()
    },
    disableProjectSelection(row) {
      if (row.row.reviewTimeLine.length) {
        if (this.isPrePreliminaryStatus(row.row.reviewTimeLine[0].dataStatus)) {
          return 'disabled'
        }
        return 'active'
      }
      return 'disabled'
    },
    expandCollapse(val) {
      this.isClosed = !this.isClosed
    },
    comparisonLoading(val) {
      this.loading = val
    },
    activeTabChanger() {
      if (this.ipData && !this.opData && !this.proData) {
        this.activeReviewTab = 'ip'
      }
      if (!this.ipData && !this.proData && this.opData) {
        this.activeReviewTab = 'op'
      }
      if (!this.ipData && !this.opData && this.proData) {
        this.activeReviewTab = 'pro'
      }
      if (!this.ipData && !this.opData && this.ambData) {
        this.activeReviewTab = 'amb'
      }
    },
    checkReviewTimelineDataStatus(reviewTimeLine, key) {
      if (reviewTimeLine.length) {
        return reviewTimeLine[0].dataStatus === key
      }
      return false
    },
    isPrePreliminaryStatus(status) {
      return status === 'Not Started' || status === 'Project Ready' || status === 'In Progress'
    },
    getProjectStatusLabel(status) {
      switch (status) {
        case 'Not Started':
          return 'Not Started (No Chart Reviewed)'
        case 'Project Ready':
          return 'Project Ready (Charts Imported)'
        case 'In Progress':
          return 'In Progress (First Chart Reviewed)'
        default:
          return status
      }
    },
    projectCommands(object) {
      if (object.action === 'openDocMgr') {
        this.openDocMgr(object.directoryLink)
      }
      if (object.action === 'viewInterimSummary') {
        let payload = {
          startDate: this.dateRange[0],
          endDate: this.dateRange[1],
          projectId: 0
          // projectId: object.row.id
        }
        const loading = this.$loading({
          lock: true,
          text: 'Getting ready...',
          spinner: 'nucleus-loader',
          background: 'rgba(255, 255, 255, 0.7)'
        })
        this.GET_INTERIM_SUMMARY_PDF_URL(payload).then(response => {
          loading.close()
          window.open(`/static/pdfjs/web/viewer.html?file=${response}`, '_blank')
        })
      }
    },
    openDocMgr(documentLink) {
      window.open(documentLink)
    },
    handleSubClientChange(val) {
      if (!val) {
        let payload = {
          subClients: this.subClients,
          startDate: this.dateRange[0],
          endDate: this.dateRange[1]
        }
        this.loading = true
        this.reviewLoading = true
        this.POST_DASHBOARD_PROJECTS_MULTIPLE(payload).then(() => {
          this.loading = false
          this.reviewLoading = false
          this.activeTabChanger()
        })
      }
    },
    handleSubClientClear() {
      let payload = {
        subClients: [],
        startDate: this.dateRange[0],
        endDate: this.dateRange[1]
      }
      this.loading = true
      this.reviewLoading = true
      this.POST_DASHBOARD_PROJECTS_MULTIPLE(payload).then(() => {
        this.loading = false
        this.reviewLoading = false
        this.activeTabChanger()
      })
    }
  },
  created: function() {
    this.initialize()
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientId', 'clients', 'user']),
    ...mapState('dashboard/', ['dashboardData', 'dashboardProjects', 'reviewDashboardData', 'selectedProjects', 'inpatientGrouping', 'inpatientStickyGroupingFilters', 'outpatientGrouping', 'outpatientStickyGroupingFilters', 'proGrouping', 'proStickyGroupingFilters', 'ambulatoryGrouping', 'ambulatoryStickyGroupingFilters']),
    ...mapState('globals/', ['dateRangePickerConfig']),
    getProjectConsultants: function() {
      let data = []
      if (this.selectedProjects.length) {
        for (let i = 0; i < this.selectedProjects.length; i++) {
          data = data.concat(this.selectedProjects[i].consultants)
        }

        data = data.reduce((accumulator, cur) => {
          let found = accumulator.find(x => {
            return x.consultant === cur.consultant
          })

          if (found) {
            if (!found.projectID.includes(cur.projectID)) {
              found.projectID += `\n ${cur.projectID}`
            }
          } else {
            accumulator.push(cur)
          }

          return accumulator
        }, [])
        return data
      }
      return data
    },
    ipData() {
      let ipIndex = this.reviewDashboardData.findIndex(x => x.type === 'inpatient') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'inpatient') : null
      if (ipIndex !== null) {
        return this.reviewDashboardData[ipIndex].largeStats.length > 0
      }
      return false
    },
    opData() {
      let opIndex = this.reviewDashboardData.findIndex(x => x.type === 'outpatient') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'outpatient') : null
      if (opIndex !== null) {
        return this.reviewDashboardData[opIndex].largeStats.length > 0
      }
      return false
    },
    ambData() {
      let opIndex = this.reviewDashboardData.findIndex(x => x.type === 'ambulatory') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'ambulatory') : null
      if (opIndex !== null) {
        return this.reviewDashboardData[opIndex].largeStats.length > 0
      }
      return false
    },
    proData() {
      let proIndex = this.reviewDashboardData.findIndex(x => x.type === 'profee') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'profee') : null
      if (proIndex !== null) {
        return this.reviewDashboardData[proIndex].largeStats.length > 0
      }
      return false
    },
    compDashboardProjects() {
      return this.dashboardProjects.filter(f => this.projectTypes.some(s => s === f.projectTypeId)).filter(f => !this.searchQuery || f.projectID.toLowerCase().includes(this.searchQuery.toLowerCase()))
    }
  },
  watch: {
    searchInput: {
      handler: debounce(function(newVal) {
        this.searchQuery = newVal
      }, 250)
    }
  }
}
</script>

<style>
#reviewTabs {
  margin: 0px 0px 0px 0px;
}

#reviewTabs .el-tabs__nav-wrap::after {
  background-color: transparent;
}

.projectsClosed {
  width: 0% !important;
  visibility: hidden;
  /* -webkit-transition: width 200ms;
    transition: width 200ms; */
}

.projectsOpen {
  visibility: visible;
  width: 20.83333% !important;
  /* -webkit-transition: width 200ms;
    transition: width 200ms; */
}

.reviewGridClosed {
  width: 100% !important;
  /* -webkit-transition: width 200ms;
    transition: width 200ms; */
}

.reviewGridOpen {
  width: 79.16667% !important;
  /* -webkit-transition: width 200ms;
    transition: width 200ms; */
}

>>> .togglePaneClosed {
  /* border-left: 1px solid rgb(235, 238, 245);
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px; */
}

#projectList .el-checkbox__inner {
  border-radius: 10px;
}

#projectList .disabled {
  /* background: #ccc; */
}

#projectList .disabled td:first-child .cell {
  display: none;
}

#projectPane:hover ~ #togglePane > #togglePaneRow {
  webkit-box-shadow: 0 2px 12px -3px rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px -3px rgba(0, 0, 0, 0.1);
}

.reviewTableData >>> .el-table--striped .el-table__body tr.el-table__row--striped td {
  /* background: rgb(238, 238, 238); */
}

.rotate::before {
  transform: rotate(-90deg);
}

.negativeNumber {
  color: #f56c6c !important;
}

.negative {
  color: #f56c6c !important;
}

.negative::before {
  content: '(';
}

.negative::after {
  content: ')';
}

.negativeNumber_td {
  color: #f56c6c !important;
}

.negative_td .cell {
  color: #f56c6c !important;
}

.negative_td .cell::before {
  content: '(';
}

.negative_td .cell::after {
  content: ')';
}

.reviewTimeline {
  cursor: pointer;
  background-color: transparent !important;
}

.reviewTimeline .el-alert__icon {
  font-size: 15px;
  width: 15px;
  margin-left: 1px;
}

.reviewTimeline .el-alert__content:hover {
  text-decoration: underline;
  /* color: rgba(236, 0, 140, 0.8); */
}

/* Review dashboard (sub-tabs) shared sticky-filter chip styles */
.dashboardControlsRow {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 10px;
}

.groupingFilterControls {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 10px;
}

.groupingControl {
  margin: 0;
  flex: 0 0 auto;
}

.codeTypeControl {
  margin: 0;
  flex: 0 0 auto;
  align-self: flex-end;
}

.rightControlActions {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-end;
  align-self: flex-end;
  gap: 10px;
}

.searchControl {
  flex: 0 0 auto;
}

.menuControl {
  flex: 0 0 auto;
}

.filterEditorContainer {
  margin: 0;
  max-width: 260px;
  overflow: hidden;
  flex: 0 0 auto;
  align-self: flex-end;
}

.inlineStickyFilters {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
  flex: 1 1 auto;
  align-content: flex-start;
  align-self: flex-end;
}

.filterEditorTrigger {
  display: inline-flex;
  cursor: pointer;
  max-width: 260px;
}

.filterChip {
  height: 28px;
  line-height: 26px;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  border: 1px solid #b9d6ff;
  border-radius: 4px;
  background-color: #eaf3ff;
  color: #245b9e;
  font-size: 12px;
  padding: 0 8px;
  overflow: hidden;
}

.clickableFilterChip {
  cursor: pointer;
  max-width: 260px;
  gap: 0;
}

.inlineStickyFilterChip {
  max-width: 260px;
}

.truncatedFilterChipLabel {
  display: inline-block;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.currentFilterChipClose {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  border-radius: 50%;
}

.currentFilterChipClose i {
  font-size: 13px;
}

.currentFilterChipClose:hover {
  background-color: rgba(36, 91, 158, 0.12);
}

.placeholderFilterChip {
  font-size: 12px;
  padding: 0 10px;
  font-weight: 400;
}

.placeholderFilterChip i {
  margin-right: 4px;
  color: inherit;
  font-size: 12px;
}

.stickyFilterChipClose {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.stickyFilterChipClose i {
  font-size: 13px;
}

.stickyFilterChipClose:hover {
  background-color: rgba(36, 91, 158, 0.12);
}

.filterEditorPopover {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filterEditorTitle {
  font-size: 12px;
  font-weight: 600;
  color: #606266;
}

.filterEditorActions {
  display: flex;
  justify-content: flex-end;
}

/* DATA TABLE STATS */
.dataTableStats {
  padding: 0px 0px 0px 0px;
  margin: 10px 0px 0px 0px;
  text-align: left;
}

.dataTableStats p {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
  font-size: 12px;
  font-weight: normal;
  color: #606266;
}

/* IP/OP Tables  */
.dataTables .el-popover__reference,
.dataTables .details,
.openUrl {
  text-decoration: underline;
  /* border-bottom: 1px dotted #000; */
  text-decoration-style: dotted;
  cursor: pointer;
}

.dataTables .caret-wrapper {
  display: none !important;
}

.dataTables thead th.ascending .cell,
.dataTables thead th.descending .cell {
  display: inline-flex !important;
  align-items: center;
}

.dataTables th.ascending .caret-wrapper,
.dataTables th.descending .caret-wrapper {
  display: inline-flex !important;
  height: 23px;
  overflow: hidden;
  flex-shrink: 0;
}

.dataTables .sort-caret.ascending {
  top: auto !important;
}

.dataTables .sort-caret.descending {
  bottom: 1px !important;
}

.dataTables thead th .cell:hover,
.dataTables thead th.ascending .cell,
.dataTables thead th.descending .cell {
  color: #005695;
  text-decoration: underline;
}

.dataTables .el-table__footer td {
  padding: 1px 0 !important;
}

.activateComparison .el-table__body .cell {
  white-space: nowrap !important;
}

.tableNoWrap .el-table__body .cell {
  white-space: nowrap !important;
}

.tableNoWrap .el-table__body .cell div[tag='description'] {
  text-transform: lowercase;
}

.expandCollapseButton {
  float: right;
  color: #ffffff;
  font-size: 21px;
  margin: 0px 0px 0px 0px;
  cursor: pointer;
  background: transparent;
  border-radius: 100%;
  margin: -3px 0px 0px 0px;
  padding: 2px 4px 2px 4px;
}

.expandCollapseButton:hover {
  float: right;
  color: rgba(19, 86, 149, 0.8);
  font-size: 21px;
  margin: 0px 0px 0px 0px;
  cursor: pointer;
  background: #ffffff !important;
  border-radius: 100%;
  margin: -3px 0px 0px 0px;
  padding: 2px 4px 2px 4px;
}

.largeCenterPopOver {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  width: 80% !important;
  max-height: 90vh !important;
  overflow-y: auto !important;
  margin: 0 !important;
}

.ellipsesIcon {
  font-size: 18px;
  color: #606266;
  float: left;
  margin: 3px 0px 0px 0px;
  padding: 0px 3px 0px 3px;
  border: 1px solid transparent;
  border-radius: 100px;
  cursor: pointer;
}

.ellipsesIcon:hover {
  font-size: 18px;
  color: #1c3c5f;
  float: left;
  margin: 3px 0px 0px 0px;
  padding: 0px 3px 0px 3px;
  border: 1px solid #1c3c5f;
  border-radius: 100px;
  cursor: pointer;
}

.vhide {
  display: none !important;
}

.vshow {
  display: block;
}

.pager {
  margin: 15px 0px 0px 0px;
  padding: 0px !important;
}

.pager .el-pager li.active {
  border-radius: 100% !important;
}

#accountNumberTableStats {
  float: left;
  width: 100%;
}

.bedSizeCompare {
  font-weight: 400 !important;
  margin-left: 0px;
  padding-left: 1px;
}

.bedSizeCompare .el-checkbox__label {
  padding-left: 6px;
}
</style>
